import React from 'react';
import Pic1 from '../../InstallImages/Modules/LG350W';


const lg400Link = <a href="https://www.dropbox.com/s/7m30f9kywoizhyt/LG_350N1C-V5.pdf?dl=0" rel="noopener noreferrer" target="_blank">Data Sheet</a>;

const lg400Video = <a href="https://www.youtube.com/watch?v=ndq0kWu8OHA" rel="noopener noreferrer" target="_blank">Watch the Video</a>;

const Module = () => (
    <div>
        <div className="col span-1-of-2">
            <Pic1 />
        </div>
        <div className="col span-1-of-2">
            <p className="specsText">
                <h2>Great Visual Appearance</h2>
                LG NeON® 2 panels have been designed with appearance in mind. Their black cells, black frames and thinner wire busbars give an aesthetically pleasing uniform black appearance. Your home deserves the LG NeON® 2.
            </p>
            <p className="specsText">
                <h2>25 Years Product Warranty (Parts & Labour)</h2>
                The LG product warranty is 15 years longer than many competitors standard 10 years. The Warranty is provided by LG Electronics Australia and New Zealand. The warranty includes replacement, labour and transport.
            </p>
            <p className="specsText">
                <h2>More Power per Square Metre</h2>
                LG NeON® 2’s 350W are a similar physical size to 25yr many competing 300W panels. This means with the LG NeON® 2 350W you get 16.6% more electricity per square metre than a 300W panel. So you can install more kW of solar on your roof with the LG NeON® 2.
            </p>
            <p className="specsText">
                <h2>Improved 25 Year Performance Warranty</h2>
                The initial degradation of the module has been improved from -3% to -2%, in the 1st year and the annual rate of degradation has fallen from -0.7%/year to -0.33%/ year thereafter. This brings an 90.08% warranted output after 25 years, compared to 80.2% for many competing panels.
            </p>
            <ul>
                <h1>Key Features</h1>
                <li className="specsText">Low Light Induced Degradation</li>
                <li className="specsText">Multi Anti-reflective Coatings Increase Output</li>
                <li className="specsText">25 Year Product Warranty</li>
                <li className="specsText">Enhanced low light performance</li>
                <li className="specsText">“CELLO” Technology Increases Power</li>
                <li className="specsText">{lg400Video}</li>
                <li className="specsText">{lg400Link}</li>
            </ul>
        </div>
    </div>
);

export default Module;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/SystemSpecs/Panels/lg350W.js